import React from 'react'
import './SignUp.css'
import { useSelector, useDispatch } from 'react-redux'
import { setFirstName, setLastName } from 'redux/actions/'
import validateNames from 'utils/validateNames'
export default function Login() {
  const dispatch = useDispatch()
  const { firstName, lastName } = useSelector(state => state.signup)
  return (
    <>
      <h1 style={{ textAlign: 'center', padding: '25px 0' }}>
        What is your full name?
      </h1>
      <div>
        <label>First Name</label>
        <input
          placeholder="John"
          type="text"
          value={firstName}
          onChange={e => dispatch(setFirstName(validateNames(e.target.value)))}
        />
        <label>Last Name</label>
        <input
          placeholder="Doe"
          type="text"
          value={lastName}
          onChange={e => dispatch(setLastName(validateNames(e.target.value)))}
        />
      </div>
    </>
  )
}
